<script setup>
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'
import authV2ForgotPasswordIllustrationDark from '@images/pages/auth-v2-forgot-password-illustration-dark.png'
import authV2ForgotPasswordIllustrationLight from '@images/pages/auth-v2-forgot-password-illustration-light.png'
import authV2MaskDark from '@images/pages/misc-mask-dark.png'
import authV2MaskLight from '@images/pages/misc-mask-light.png'
import { integerValidator } from '@/@core/utils/validators'
import { useRouter } from 'vue-router'
import { useGlobalVariablesStore } from '@/composables/useGlobalStore'
import UsersController from '@/Controller/users'
import { useLocalizedValidators } from '@/composables/validators'

const { localizedRequired, localizedInteger, localizedMobile } = useLocalizedValidators()

const router = useRouter()
const mobile = ref('')
const authThemeImg = useGenerateImageVariant(authV2ForgotPasswordIllustrationLight, authV2ForgotPasswordIllustrationDark)
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)
const globalVariables=useGlobalVariablesStore()
const sendingSms=ref(false)
definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})

const sendSms=async()=>{
  sendingSms.value=true
  globalVariables.mobileToVerify=mobile.value
  var setValidateResult=await UsersController.setValidationCode(mobile.value)
  if(setValidateResult==mobile.value){
    router.push('/validate-mobile-for-reset-password')
  }
}
</script>

<template>
  <RouterLink to="/">
    <div class="auth-logo d-flex align-center gap-x-3">
      <VNodeRenderer :nodes="themeConfig.app.logo" />
      <h1 class="auth-title">
        {{ $t(themeConfig.app.title) }}
      </h1>
    </div>
  </RouterLink>

  <VRow
    class="auth-wrapper bg-surface"
    no-gutters
  >
    <VCol
      cols="12"
      md="8"
      class="d-flex align-center justify-center"
    >
      <VCard
        flat
        :max-width="500"
        class="mt-12 mt-sm-0 pa-4"
      >
        <VCardText>
          <h4 class="text-h4 mb-1 text-center">
          {{$t('Password verification')}}
          </h4>
          <p class="mb-0 mt-3 text-center">
            {{$t("Please enter your mobile number to continue.")}}
          </p>
        </VCardText>

        <VCardText>
          <VForm @submit.prevent="() => {}">
            <VRow>
              <!-- phone -->
              <VCol cols="12">
                <AppTextField
                  v-model="mobile"
                  autofocus
                  :label="$t('Mobile Number')"
                  prepend-inner-icon="tabler-device-mobile"
                  placeholder="مثلا 09198528524"
                  :rules="[localizedRequired, localizedInteger, localizedMobile]"
                />
              </VCol>

              <!-- Reset link -->
              <VCol cols="12">
                <VBtn
                  block
                  class="rounded-lg"
                  :color="localizedMobile(mobile)!==true || localizedRequired(mobile)!==true ? 'secondary':'primary'"
                  :disabled="localizedMobile(mobile)!==true || localizedRequired(mobile)!==true || sendingSms"
                  type="submit"
                  @click="sendSms"
                >
                  {{ $t('Confirm and receive code') }}
                </VBtn>
              </VCol>

              <!-- back to login -->
              <VCol cols="12">
                <RouterLink
                  class="d-flex"
                  :to="{ name: 'login' }"
                >
                  <VIcon
                    icon="tabler-transfer"
                    size="20"
                    class="me-1 flip-in-rtl"
                  />
                  <span>{{$t('Back to login')}}</span>
                </RouterLink>
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </VCol>

    <VCol
      md="4"
      class="d-none d-md-flex"
    >
      <div class="position-relative bg-background w-100 me-0">
        <div
          class="d-flex align-center justify-center w-100 h-100"
        >
          <VImg
            max-width="468"
            :src="authThemeImg"
            class="auth-illustration mt-16 mb-2"
          />
        </div>

        <img
          class="auth-footer-mask"
          :src="authThemeMask"
          alt="auth-footer-mask"
          height="280"
          width="100"
        >
      </div>
    </VCol>
  </VRow>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
